import React from "react";
import { string } from "prop-types";

import { useAgentMatchData } from "../../redux/hooks/agentMatchHooks";
import { useAnalyticsBehavior } from "../../redux/hooks/analyticsHooks/useAnalyticsBehavior";
import { useUIBehavior } from "../../redux/hooks/uiHooks";
import SellerLandingCTA from "../SellerLandingCTA";
import * as S from "./styled";

const MessageSent = ({
  ariaContentDescribedBy,
  ariaContentLabelledBy,
  className
}) => {
  const { agentName } = useAgentMatchData();
  const { sendClickToSellHomepageEvent } = useAnalyticsBehavior();
  const { closeExpertMatchDrawer } = useUIBehavior();

  return (
    <div className={className} data-qa="seller-inquiry-success-modal">
      <S.SuccessMessageContainer>
        <S.CheckMarkContainer>
          <S.CheckMark />
        </S.CheckMarkContainer>
        <S.SuccessTitle id={ariaContentLabelledBy}>
          Message Sent!
        </S.SuccessTitle>
        <S.SuccessTextContainer>
          <S.SuccessText id={ariaContentDescribedBy}>
            You&apos;ll hear from {agentName} shortly.
          </S.SuccessText>
        </S.SuccessTextContainer>
      </S.SuccessMessageContainer>
      <S.CTAContainer>
        <SellerLandingCTA
          handleCloseClick={closeExpertMatchDrawer}
          handleLinkClick={sendClickToSellHomepageEvent}
          href="/sell-your-home"
        />
      </S.CTAContainer>
    </div>
  );
};

MessageSent.propTypes = {
  ariaContentDescribedBy: string,
  ariaContentLabelledBy: string,
  className: string
};

MessageSent.defaultProps = {
  ariaContentLabelledBy: null,
  ariaContentDescribedBy: null,
  className: ""
};

export default MessageSent;
